import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

export interface ZoneLink {
  label: string;
  to: string;
}

interface ZoneLinksProps {
  title: string;
  intro?: string;
  links: readonly ZoneLink[];
  id?: string;
}

/** Bloc « Zones d'intervention » : pastilles de liens internes vers les pages locales. */
const ZoneLinks: React.FC<ZoneLinksProps> = ({ title, intro, links, id }) => (
  <section id={id} className="section-spacing bg-canvas border-t border-line" aria-label={title}>
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="heading-section mb-3">{title}</h2>
      {intro && <p className="text-fg-muted text-sm md:text-base max-w-2xl mx-auto mb-6">{intro}</p>}
      <ul className="flex flex-wrap gap-3 justify-center">
        {links.map(({ label, to }) => (
          <li key={to}>
            <Link
              to={to}
              className="flex min-h-11 items-center gap-2 bg-white/5 hover:bg-accent-strong/20 border border-line hover:border-accent/50 text-fg-muted hover:text-fg px-4 py-2 rounded-full text-sm transition-colors md:min-h-0"
            >
              <MapPin className="w-3.5 h-3.5 text-accent-soft" aria-hidden="true" /> {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default ZoneLinks;
